import { RetailItem } from './retail-item';

export class ConditionRetail
{
    id: number|undefined;
    code:String;
    label:String;
    checked:Boolean;
    isDeleted:Boolean;
    createBy:String;
    createAt:String;
    updateBy:String;
    updateAt:String;
    retailItem:RetailItem;
}